__turbopack_context__.v({
  "a": "AppLink-module-scss-module__HGA7aq__a",
});
